import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    OnDestroy,
    OnInit,
    input,
} from '@angular/core';
import { BazisConfigurationService } from '@bazis/configuration.service';
import { BazisBreadcrumbsService } from '@bazis/shared/services/breadcrumbs.service';
import { BazisMediaQueryService } from '@bazis/shared/services/media-query.service';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { CommonModule } from '@angular/common';
import { OrganizationPipe } from '@bazis/shared/pipes/organization.pipe';
import { RouterLink } from '@angular/router';
import { EntityPipe } from '@bazis/shared/pipes/entity.pipe';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'bazis-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    imports: [
        IconModule,
        ButtonModule,
        CommonModule,
        OrganizationPipe,
        RouterLink,
        EntityPipe,
        TranslocoModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent implements OnDestroy, OnInit {
    // TODO: (пометка для себя)
    // Идеи из https://ionicframework.com/docs/api/breadcrumbs
    // посмотреть вариант доработки до web- компонента

    public breadcrumbs = inject(BazisBreadcrumbsService);

    public mqSrv = inject(BazisMediaQueryService);

    protected configurationService = inject(BazisConfigurationService);

    readonly iconSeparator = input<string>();

    readonly doNotDisplayLength = input<number>(1);

    list$ = this.breadcrumbs.breadcrumbs$;

    readonly separator = computed(() => {
        return this.iconSeparator() || this.configurationService.breadcrumbsIconSeparator;
    });

    ngOnInit(): void {}

    ngOnDestroy(): void {}
}
